<template>
  <v-app>

    <v-app-bar app color="white" height="70">
      <v-container class="py-0">
        <v-row>
          <v-col cols="7" lg="3" class="pa-0">
            <h1 class="logo pa-2 pa-lg-0">
              <img :src="`${apiUrl}/assets/logo-shop.jpg`"/>
              <a :href="`${apiUrl}`" class="navbar-brand">PTITPINGOUIN<small>.COM</small></a>
            </h1>
          </v-col>
          <v-col cols="5" lg="9" class="pa-0 align-content-stretch justify-end d-flex">
            <div class="d-none d-lg-flex px-0 align-content-stretch">
              <Menu v-bind:items="menuItems" />
            </div>
            <!-- Lang icon -->
            <div class="nav-item lang-menu">
              <LangMenu :locale="selectedLocale" v-on:on-change-locale="forceRerender"/>
            </div>
            <!-- Burger icon -->
            <div class="d-flex d-lg-none align-center">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn light
                         icon
                         v-bind="attrs"
                         v-on="on"
                  >
                    <v-icon>mdi-menu</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item v-for="(item, i) in menuItems" :key="i">
                    <v-list-item-title>
                      <a v-if="item.locale" :href="`/${item.locale}/${item.url}`">{{ item.label|globalTranslate }}</a>
                      <a v-if="!item.locale" :href="`/${item.url}`">{{ item.label|globalTranslate }}</a>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <!-- Cart icon -->
            <div class="d-flex align-center mr-2 mr-lg-0">
              <CartMenu :count="cartProductsCount()" v-on:show-cart="showCart"/>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog
          v-model="dialog"
          max-width="1000"
          persistent
          scrollable>
        <Cart :cart-products="cartProducts()" @cancel="closeCart" :key="routerKey" @finish="checkout"/>
      </v-dialog>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main>

      <div class="custom-header">
        <v-container>
          <v-row>
            <v-col cols="12 white--text text-center">
              <h2 class="text-h4 font-weight-bold text-uppercase"><span
                  class="primary--text">{{ 'ski_rental'|globalTranslate }}</span>
                {{ 'at'|globalTranslate }}
                VILLARD RECULAS</h2>
              <h3 class="text-uppercase font-weight-bold">Alpe d'huez grand domaine</h3>
              <p class="text-uppercase">{{ 'no_deposit'|globalTranslate }}</p>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="primary navigation">
        <v-container class="white--text">
          <v-row>
            <v-col cols="12" md="4" class="text-center cursor-pointer" v-for="(link, k) in links" :key="k">
              <v-btn class="primary--text text-h6 font-weight-bold mr-2" fab depressed light small>
                {{ k + 1 }}
              </v-btn>
              <v-btn active-class="active-link" large light text rounded :to="link.url"
                     class="text-h6 text-uppercase white--text font-weight-bold">
                {{ link.label|globalTranslate }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- If using vue-router -->
      <router-view :key="routerKey" v-on:show-cart="showCart" v-on:go-to-checkout="checkout"></router-view>
    </v-main>

    <footer class="bg-footer">
      <v-container>
        <v-row>
          <v-col cols="12" md="8">
            <ul class="footer-menu d-flex text-uppercase px-0 flex-wrap unstyled mb-10 mb-sm-0">
              <li v-for="(item,k) of menuItems" :key="k" :class="`pa-3 mr-2 ${item.class}`">
                <a v-if="item.locale" :href="`/${item.locale}/${item.url}`">{{ item.label|globalTranslate }}</a>
                <a v-if="!item.locale" :href="`/${item.url}`">{{ item.label|globalTranslate }}</a>
              </li>
            </ul>
            <div class="white--text text-center text-sm-left">
              <v-icon class="mr-2 white--text">mdi-email</v-icon>
              <a class="text-decoration-none" :href="`mailto:${shopEmail}`">{{shopEmail}}</a>
            </div>
            <ul class="unstyled my-4 px-0 white--text text-center text-sm-left">
              <li>{{shopName}}</li>
              <li>{{shopAddress}}</li>
              <li>{{shopZipcode}} {{shopCity}}</li>
              <li>FRANCE</li>
            </ul>
            <div class="text-h5 primary--text font-weight-bold text-center text-sm-left">
              <v-icon class="mr-2 primary--text" large>mdi-phone</v-icon>
              {{shopPhone}}
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="text-center">
              <div class="fb-page fb_iframe_widget"
                   data-href="http://www.facebook.com/pages/Le-Ptit-Pingouin/329755960659"
                   data-small-header="false" data-adapt-container-width="true" data-hide-cover="false"
                   data-show-facepile="true" data-show-posts="false" fb-xfbml-state="rendered"
                   fb-iframe-plugin-query="adapt_container_width=true&amp;app_id=&amp;container_width=350&amp;hide_cover=false&amp;href=http%3A%2F%2Fwww.facebook.com%2Fpages%2FLe-Ptit-Pingouin%2F329755960659&amp;locale=fr_FR&amp;sdk=joey&amp;show_facepile=true&amp;show_posts=false&amp;small_header=false">
                            <span style="vertical-align: bottom; width: 340px; height: 181px;">
                            <iframe name="f1a822ba9ad5616" width="1000px" height="1000px"
                                    data-testid="fb:page Facebook Social Plugin" title="fb:page Facebook Social Plugin"
                                    frameborder="0" allowtransparency="true" allowfullscreen="true" scrolling="no"
                                    allow="encrypted-media"
                                    src="https://www.facebook.com/v2.4/plugins/page.php?adapt_container_width=true&amp;app_id=&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df5835cb2540aac%26domain%3Dwww.ptitpingouin.com%26origin%3Dhttps%253A%252F%252Fwww.ptitpingouin.com%252Ff360ec65df325a2%26relation%3Dparent.parent&amp;container_width=350&amp;hide_cover=false&amp;href=http%3A%2F%2Fwww.facebook.com%2Fpages%2FLe-Ptit-Pingouin%2F329755960659&amp;locale=fr_FR&amp;sdk=joey&amp;show_facepile=true&amp;show_posts=false&amp;small_header=false"
                                    class=""
                                    style="border: none; visibility: visible; width: 340px; height: 181px;"></iframe>
                        </span>
              </div>
            </div>
          </v-col>
          <v-col>
            <small class="mt-4 d-block white--text text-center">
              &copy; 2004-2022 {{shopName}} SARL | <a href="/fr/mentions-legales">{{ 'legal_notice'|globalTranslate }}</a> | <a href="">CGV</a> | Réalisation : <a
                class="text-decoration-none" href="https://www.la-dame-du-web.com">Agence La Dame du Web</a>
            </small>
          </v-col>
        </v-row>
      </v-container>
    </footer>
  </v-app>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import Cart from "@/components/Cart";
import Menu from "@/components/Menu";
import LangMenu from "@/components/LangMenu";
import CartMenu from "@/components/CartMenu";
import Config from "@/config";

export default {
  name: "App",
  components: {Cart, Menu, LangMenu, CartMenu},
  computed: {
    ...mapGetters({
      cartProducts: "cart/getProducts",
      cartProductsCount: "cart/getProductsCount"
    }),
    ...mapState(["selectedLocale", "cart"])
  },
  data: function () {
    return {
      apiUrl: Config.API_URL,
      dialog: false,
      links: [
        {label: 'navigation.selection', url: '/'},
        {label: 'navigation.checkout', url: '/checkout'},
        {label: 'navigation.finish', url: null}
      ],
      menuItems: [],
      navigationKey: 0,
      routerKey: 0,
      shopAddress: Config.SHOP_ADDRESS,
      shopCity: Config.SHOP_CITY,
      shopEmail: Config.SHOP_EMAIL,
      shopName: Config.SHOP_NAME,
      shopPhone: Config.SHOP_PHONE,
      shopZipcode: Config.SHOP_ZIPCODE
    }
  },
  methods: {
    buildMenuItemsObject(locale) {
      this.menuItems = [
        {label: 'menu.accueil', url: ""},
        {label: 'menu.team', url: "l-equipe", locale},
        {label: 'menu.prices', url: "ski-tarifs", locale},
        {label: 'menu.contact', url: "contact", locale},
        {label: 'menu.practical', url: "partenaires", locale},
        {label: 'menu.booking', url: 'reservez-vos-skis-en-ligne', class: 'reserver', locale: null},
      ];
    },
    closeCart() {
      this.dialog = false;
    },
    forceRerender() {
      this.routerKey += 1;
      // Rebuild the menu since locale state change can't be catched inside object (the whole object must change)
      this.buildMenuItemsObject(this.selectedLocale);
    },
    checkout() {
      window.scrollTo(0,0);
      this.closeCart();
      this.$router.push("checkout");
    },
    showCart() {
      this.dialog = true;
    }
  },
  mounted() {
    this.buildMenuItemsObject(this.selectedLocale);
  }
};
</script>

<style scoped>
.active-link {
  background-color: red;
}

.custom-header {
  background-image: url("assets/bg-header.jpg");
  background-size: cover;
  background-position: center;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.32422rem;
  padding-bottom: 0.32422rem;
  font-size: 15px;
  line-height: inherit;
  white-space: nowrap;
  text-decoration: none;
}

@media (min-width: 470px) {
  .navbar-brand {
    font-size: 25px;
  }
}

.logo img {
  max-width: 50px;
  vertical-align: middle;
  margin-right: 10px;
}

.logo small {
  font-weight: normal;
}

/deep/ .v-toolbar__content {
  padding: 0px !important;
  align-items: inherit;
  overflow: hidden;
}

/deep/ .v-toolbar__content .row {
  height: 100%;
}

/deep/ .v-text-field fieldset {
  border-radius: 0 !important;
}

.bg-footer {
  background-image: url("assets/banner-footer.jpg");
  background-size: cover;
  background-position: center;
  background-color: #1E1E1E;
}

.unstyled {
  list-style: none;
}

.nav-item {
  line-height: 70px;
}

.footer-menu a {
  color: white;
  text-decoration: none;
}
</style>
